import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ObjectParams } from '@/hooks/use-relation-insert';
import { useKeycloak } from '@react-keycloak/web';

export interface DeletePayload {
  target: ObjectParams;
  objects: ObjectParams[];
  attribute: string;
}

export function useRelationDelete() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async (payload: DeletePayload) => {
      const res = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/bundles/crud_bundle/functions/delete_relation`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: payload ? JSON.stringify(payload) : '',
        }
      );

      return res.json();
    },
  });
}
